import { render } from "./kanban01.vue?vue&type=template&id=259d8227&scoped=true"
import script from "./kanban01.vue?vue&type=script&lang=js"
export * from "./kanban01.vue?vue&type=script&lang=js"

import "./kanban01.vue?vue&type=style&index=0&id=259d8227&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259d8227"]])

export default __exports__